import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Landing from "@/pages/Landing";
import Reader from "@/pages/Reader";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import { ThemeProvider } from "@/lib/theme";

const TOAST_OPTIONS = {
  style: {
    fontFamily: 'Outfit, system-ui, sans-serif',
    background: 'hsl(var(--card))',
    color: 'hsl(var(--card-foreground))',
    border: '1px solid hsl(var(--border))',
    borderRadius: '999px',
  },
};

function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <div className="App min-h-screen flex flex-col bg-background text-foreground">
          <Navigation />
          <div className="flex-1">
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/read" element={<Reader />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Landing />} />
            </Routes>
          </div>
          <Footer />
          <Toaster position="bottom-center" toastOptions={TOAST_OPTIONS} />
        </div>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
